import {
  Component,
  Inject,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from 'app/models';
import { SelectedUserService } from 'app/services';
interface Data {
  user: any;
  clientId?: any;
}
@Component({
  standalone: false,
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls: ['./user-dialog.component.scss']
})
export class UserDialogComponent {
  public user: User;
  public loading = true;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Data,
    private _selectedUserService: SelectedUserService
  ) {
    if (data.user) {
      const id = data.user.authID || data.user.id;
      this._selectedUserService.getSelectedUser(id);
    }
  }

  setLoading(event) {
    this.loading = event;
  }

}
